var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "navbar_feedback") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-184, -27)",
    stroke: "#0E1C39",
    strokeWidth: 1.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(188, 30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,4.7484542 L14.0629536,4.7484542 C13.7978569,4.7484542 13.5829536,4.53355088 13.5829536,4.2684542 L13.5829536,0.048 C13.5829536,0.021490332 13.6044439,4.48798614e-17 13.6309536,4.16333634e-17 L15.2442702,0 C16.16179,-1.68545655e-16 16.9055867,0.743796767 16.9055867,1.66131658 L16.9055867,7.59752671 C16.9055867,11.7935249 13.5040582,15.1950534 9.30806002,15.1950534 L7.6948857,15.1950534 C3.49888756,15.1950534 0.0973589847,11.7935249 0.0973589847,7.59752671 L0.0973589847,1.66131658 C0.0973589847,0.743796767 0.841155751,1.74220636e-15 1.75867556,0 L3.37199214,-6.9388939e-18 C3.39850181,-2.47261791e-16 3.41999214,0.021490332 3.41999214,0.048 L3.41999214,4.2684542 C3.41999214,4.53355088 3.20508882,4.7484542 2.93999214,4.7484542 L0,4.7484542 L0,4.7484542",
    id: "\\u77E9\\u5F62",
    transform: "translate(8.5, 7.5975) rotate(-180) translate(-8.5, -7.5975)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.0041304,15.1950534 C2.0041304,17.2964674 3.70766301,19 5.80907697,19 L7.69047619,19 L7.69047619,19",
    id: "\\u8DEF\\u5F84-3",
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarFeedback);
export default __webpack_public_path__ + "static/media/navbar_feedback.b14a04df70411017b8e40e4437a4dcb4.svg";
export { ForwardRef as ReactComponent };